import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseAlignmentOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-alignment-option';
import type {TextHorizontalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromTextStylesOfSelectedTextSlideItem} from '@Hooks/poster-editor/useGetKeyFromTextStylesOfSelectedTextSlideItem';

interface TextSlideAlignmentOptionProps {
  showLargeIcons?: boolean;
  text?: string;
}

export function TextSlideAlignmentOption({showLargeIcons = false, ...props}: TextSlideAlignmentOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const textAlign = useGetKeyFromTextStylesOfSelectedTextSlideItem('textAlign');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (textAlign === undefined) {
    throw new Error('unable to get text align for text slide item');
  }

  const onClickHandler = (clickedId: TextHorizontalAlignType): void => {
    void activeItem.updateSlideFromObject(activeSlideUID, {
      textStyles: {
        textAlign: clickedId,
      },
    });
  };

  return <ItemBaseAlignmentOption text={props.text} showLargeIcons={showLargeIcons} selectedAlignment={textAlign} onClickAlignmentOption={onClickHandler} />;
}
